"use client";
import { useEffect, useRef } from "react";
// import { useAtomValue } from "jotai";
// import { globalSpinnerAtom } from "../store/layoutStore";

export const useOutsideClick = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);
  // const isGlobalLoading = useAtomValue(globalSpinnerAtom);
  useEffect(() => {
    // if (isGlobalLoading) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };
    const handleClickEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape" && ref.current) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleClickEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleClickEsc);
    };
  }, [callback /*isGlobalLoading*/]);

  return ref;
};
